// 英文
export default {
  // 首页
  page_home: {
    navMenu: {
      home: "Home",
      caseExchange: "Case Exchange",
      surgicalVideo: "Surgical Videos",
      internationalConference: "International Conferences",
      medicalInformation: "Medical Information",
      aboutUs: "About Us",
      aboutTeam: "About our Team",
      contactUs: "Contact Us",
      businessPartner: "Our Partners",
      privacyAgreement: "Privacy Policy",
    },
    footer: {
      address:
        "21 / F, Building A, Jintang Center, 18 Fengtai North Road, Fengtai District, Beijing",
      email: "misnmed@gmail.com",
      jnd: "Canada",
      jndaddress: "Vancouver",
      beijing: "China ",
      lookMore: "Browse More",
      phone:'(001)6046571180',
    },
    carousel:{
      left:'Join now',
      right:'Learn more',
    },
    wc: {
      title:
        "Bringing together globally recognized medical experts, a premier international platform for minimally invasive surgery.",
      zjtd: "Expert Team",
      zjtd_desc:
        "Tens of thousands of senior doctors, covering various specialty fields, escort medical quality with professional strength",
      gjlt: "International forum",
      gjlt_desc:
        "Gather the wisdom of global doctors, share clinical experience, and talk about difficult cases",
    },
    zj: {
      title: "Our Respected Fellow Experts",
      desc: "Medical experts work deeply in the field, provide authoritative and reliable diagnosis and treatment plans for patients with superb medical skills and profound knowledge, and protect every moment of life.",
      cyjy: "Working experience",
      ssal: "Operation case",
      xx:'Detailed',
    },
    pt: {
      title:
        "Sharing and exchanging surgical videos，on our highly trusted professional medical platform.",
    },
    pl: {
      title: "Hear from Our Users",
    },
    case: {
      title1: "Medical scholars through the MISN platform",
      title2:
        "A large number of cases have been shared to facilitate medical exchanges and research",
      csyy: "Come and speak freely",
      gdbl: "More Cases",
    },
    zx: {
      title: "Medical Consultation",
      gdzx: "More information",
      lll: "Page view",
    },
    cj: {
      title: "Medical device manufacturers settled in",
      desc: "So you don't have to worry about how to buy",
      llxq: "Learn more",
    },
  },
  // 病例交流
  page_caseExchange: {
    pushBl: "Post Case",
    fbyy: "Post Language",
    pl: "Comments",
    fbpl: "Post a review",
    djsrpl: "Click to enter comments",
    delete: "Delete",
    recover: "Recover",
    fycyw: "Translate into English",
    srplnr: "Please enter a comment",
    plcg: "Review success",
    fyz: "Translating...",
  },
  // 手术视频
  page_surgicalVideo: {
    spzt: "Video Topics",
    fbsp: "Post Video",
    tj: "Recommended",
    tjsp: "Recommended video",
    follow: "Follow",
    sc: "Be good at",
    blxx: "Case Information",
  },
  // 国际会议
  page_internationalConference:{
    meetingTime:"Meeting time",
    createTime:"Creation time"
  },
  // 团队介绍
  page_aboutTeam: {
    misn: "MISN Minimally Invasive Surgeons Network",
    misnDesc:
      "Minimally Invasive Surgeons Network (MISN) is a prestigious global alliance of world-renowned medical experts from diverse disciplines. With the rapid evolution of minimally invasive and robotic surgery, there is an urgent need for a premier international platform to facilitate the exchange of cutting-edge techniques, the sharing of expertise, and the dissemination of groundbreaking research, as well as to advance specialized global training. MISN provides an exclusive and highly specialized digital forum that cultivates global collaboration, propels technological innovation, and serves as a cornerstone in shaping the future of minimally invasive surgery within the international medical community.",
    teamMem: "Team Members",
    acadSem: "Academic Seminars",
  },
  // 关于我们
  page_aboutUs: {
    khfw: "Customer service",
    jghz: "Institutional Collaboration",
    schz: "MISN SPONSORS",
    gzsjdd: "Address",
    gztime: "Monday to Friday 9:00-18:00",
    hzcjrz: "Cooperative manufacturers settle in",
    hzcjLogin: "Partner manufacturer login",
    hzcj: "Cooperative manufacturer",
    cpxx: "Product Information",
    hzcjrzDesc:
      "Release the company's exclusive product information on the platform, fill in the information, immediately enter it!",
    ckgd:'View more',
  },
  // 个人中心
  page_userCenter: {
    edit: "Edit",
    video: "Video",
    sc: "Favorites",
    all: "All",
    gk: "Public",
    sm: "Private",
    shz: "Under Review...",
    shwtg: "Review Not Approved...",
    caseDeleteTitle: "The deletion cannot be restored",
    caseDeleteDesc: "Do you want to delete it?",
    caseDeleteBtn: "Confirm deletion",
    caseCancleBtn: "Cancel",
    yqts: "Friendly reminder",
    yqtsDesc:
      "All uploaded case records must have the patient’s consent and must not disclose any patient privacy. This website assumes no related liability.",
    yqtsVideoDesc:
      "All uploaded videos must have the patient’s consent and ensure that no patient privacy is involved. This website assumes no corresponding responsibility.",
    wyzxbty: "I know and agree",
    queren: "Verify",
    grxx: "Personal information",
    gh: "switch",
    fansList: "Followers list",
    followList: "Following list",
    zxfb: "Latest release",
    zdbf: "Maximum play",
    zddz: "Maximum likes",
    caseEditTip: "Unable to edit under review",
    nhmysc: "You don't have a collection",
    zwllsj: "No browsing data available",
  },
  // 厂家的
  page_mf: {
    addpro: "New product",
    yyly: "Application field",
    qxzyjly: "Please select a Level 1 field",
    qxzejly: "Please select a secondary field",
    xzcg: "New success",
    xgcg: "Edit successfully",
    bjxx: "Edit information",
  },
  // 表单
  form: {
    cjmc: "Manufacturer name:",
    cjmcEn:'English name of the manufacturer:',
    cjlogo: "Manufacturer logo:",
    lxdh: "Phone Number:",
    email: "Email:",
    cjjs: "Manufacturer introduction:",
    cjjsEn:'English Introduction of the manufacturer:',  
    loginPwd: "Login password:",
    confirmPwd: "Confirm password:",
    qsr: "Please enter",
    qxz: "Please select",
    xzwj: "Select file",
    xzwjTip:
      "Please upload the image in jpg, jpeg, png format and the size does not exceed 2M",
    ydbty: "Read and agree",
    // userxy:'《User Agreement》',
    ysxy: "《Privacy Agreement》",
    mzsf: "《Disclaimer》",
    submit: "Submit",
    submitSuccessTitle:
      "You have submitted successfully! Wait for staff review",
    submitSuccessDesc: "It is expected to be processed within 3 working days",
    dxdl: "SMS login",
    yxdl: "Email login",
    hqyzm: "Get verification code",
    dxyz: "SMS authentication",
    emailyz: "Mailbox verification",
    cshi: "Retry",
    qstyxy: "Please agree to the agreement first",
    zccg: "Registered successfully",
    fscg: "Sent successfully",
    signCg: "Login successful",
    saveSucc: "Save successfully",
    qtnzddl: "Automatic login within seven days",
    xs: "Last name:",
    name: "First name:",
    country: "Country:",
    zyly: "Professional field:",
    otherZyly:'Other professional fields:',
    grjj: "Personal profile:",
    ywjj: "Introduction to English:",
    ywjjzh:'Introduction to Chinese:',
    sc: "Good at:",
    ywsc: "Good at English:",
    ywsczh:'Good at Chinese:',
    sjh: "Phone Number:",
    bcxg: "Save changes",
    bt: "Title:",
    fl: "Sort:",
    blxx: "Case information:",
    chzzl:
      'Describe the real situation of the operation from the aspects of patient data, physical examination, disease diagnosis, etc., and the system will automatically polish and fill in the "case information" for you',
    runse: "AI Polish",
    fbfw: "Release scope:",
    gk: "Public (visible to all users)",
    rc: "Daily work medical records (visible only to oneself)",
    fhbj: "Back to edit",
    qrfb: "Confirm release",
    tjcg: "You have submitted successfully",
    tzdccyksc: "Drag and drop here to upload",
    zc: "Support.mp4.mov.avi",
    scvideo: "Upload video",
    ghvideo: "Replace video",
    scsuccess: "Upload complete",
    scfail: "Upload failure",
    yscdvideo: "Videos have been uploaded",
    fm: "Cover:",
    ghfm: "Change cover",
    xtmrdyz: "By default, the first frame is selected as the video cover",
    cpmc: "Product name:",
    cpmcEn:'English name of the product:',
    yyly: "Application field:",
    cptp: "Product picture:",
    cpjs: "Product introduction:",
    cpjsEn:'Product English Introduction:',
    sphzscz:'The video is still being uploaded',
    xgai:'Modify',
    bind:'Binding',
    save:'Save',
    editEmail:'Modify the email address',
    editPhone:'Modify the mobile phone number',
    bingPhone:'Bind the mobile phone number',
    pl_qxafm: "Please select cover",
    pl_qsrYzm: "Please enter the verification code",
    pl_qsrsjh: "Please enter your phone number",
    pl_qsrnewsjh:'Please enter a new mobile phone number',
    pl_qxzzyly: "Please select a field of specialization",
    pl_qsrzyly:'Please enter your professional field',
    pl_qsrgj: "Your country",
    pl_qsrxs: "Please enter last name",
    pl_qsrmz: "Please enter first name",
    pl_qsrcjmc: "Please enter the manufacturer name",
    pl_qsrcjmcEn:'Please enter the English name of the manufacturer',
    pl_qsrlogo: "Please upload manufacturer logo",
    pl_qsrphone: "Please enter a contact number",
    pl_qsrzqPhone: "Please enter the correct phone number",
    pl_qsrEmail: "Please enter email",
    pl_qsrnewEmail:'Please enter a new email address',
    pl_qsrzqEmail: "Please enter the correct email address",
    pl_qsrCjjs: "Please enter manufacturer description",
    pl_qsrCjjsEn:'Please enter the English introduction of the manufacturer',
    pl_qsrPwd: "Please enter your login password",
    pl_qsrConfirmPwd: "Please enter your confirmation password",
    pl_qsrbt: "Please enter the title",
    pl_qszfl: "Please select category",
    pl_qsrblxx: "Please enter the case information",
    pl_qsrFbfw: "Please select a publication scope",
    pl_qsrmm: "Please enter password",
    pl_qsccptp: "Please upload product pictures",
    pl_qszyyly: "Please select the application field",
    pl_qsrcpmc: "Please enter the product name",
    pl_qsrcpmcEn:'Please enter the English name of the product',
    pl_qsrcpjs:'Please enter the product introduction',
    pl_qsrcpjsEn:'Please enter the English introduction of the product',
  },
  new: "Recent Updates",
  hot: "Top Updates",
  jjjx:'Upcoming Conferences',
  wqhy:'Past Conferences',
  search: "Search",
  searchTip: "Please enter your search",
  loading: "Loading...",
  noMore: "No more data",
  noMoreJQQD: "More content is coming soon",
  hmyfbnr: "Haven't released the content yet",
  back: "Back",
  dyue: "Subscribe to",
  fans: "Followers",
  bl: "Case",
  myBl: "My case",
  mySp: "My video",
  mySc: "My collection",
  lljl: "Browsing History",
  lang: "Language",
  exit: "Sign Out",
  noSearchData: "No data found",
  yxzx: "Medical Information",
  user: "User",
  qxGz: "Unfollow",
  hg: "Follow Back",
  hxgz: "Focus on each other",
  ststemNot: "System notification",
  llck: "View now",
  srbt: "Enter Title",
  detail: "Details",
  backLogin: "Back to login",
  register: "Sign up",
  sign: "Log In",
  registerBottomTip:
    "Due to regional restrictions in some countries, if you do not receive SMS verification code, please use email registration.",
  sftcdl: "Do you want to log out?",
  runseFail: "Polishing failure",
  sfsc: "Do you want to delete?",
  sccg: "Successfully deleted",
  mmsrbyz: "The two password entries are inconsistent",
  sdskz: "In deep thought...",
  sdskzFinish:'Deep thinking completed',
  qxgxy: 'Please tick "Agree" first',
  qxdl:'Please log in first.',
  zdfbpdNUm:'A maximum of 10 products can be released',
  dlhjkgksp:'You can watch the full video after logging in',
  message:"Message",
  zanwu:'Not yet',
  sysc:'User Manual',
  pcv:'PC Version',
  mobilev:'Mobile Version',
  m_pcv:'PC Version User Manual',
  m_mobilev:'Mobile Version User Manual',
  loginTip1:"If you don't have an account yet, please",
  loginTip2:'first and then log in.',
  bannerWorld1:'Join MISN and become a valued part of an exceptional team, dedicated to',
  bannerWorld2:'advancing innovation in minimally invasive technology worldwide.',
  zh:'Chinese',
  // 隐私协议
  privacyAgreement: {
    title: "Privacy Policy of Minimally Invasive Surgeons Network",
    t1: {
      t: "一、Introduction",
      d: "We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, store, and protect your information when you use our platform.",
    },
    t2: {
      t: "二、What We Collect",
      d: "We may collect the following data strictly for professional purposes:",
      d1: "1.	Identity Information (Name, profession, hospital/organization, medical license number)",
      d2: "2.	Contact Details (Email, phone number, country/region)",
      d3: "3.	Account Activity (Login records, viewing history, upload logs)",
      d4: "4.	Professional Content (Videos uploaded, comments, Medical cases, etc.)",
      d5: "5.	Device Information (IP address, OS, browser type – for security purposes only)",
    },
    t3: {
      t: "三、How We Use Your Data",
      d1: "1.	To verify physician identities to maintain the platform’s professionalism and trustworthiness;",
      d2: "2.	To deliver personalized services and recommend relevant academic content;",
      d3: "3.	To manage content publishing and expert review processes;",
      d4: "4.	To enhance platform performance and improve user experience;",
      d5: "5.	To Fulfill legal, regulatory, and compliance obligations.",
    },
    t4: {
      t: "四、Data Storage & Protection",
      d1: "•	All data is encrypted and stored in compliance-secured servers;",
      d2: "•	Users may request data deletion or export at any time.",
    },
    t5: {
      t: "五、Third-Party Sharing",
      d: "We will not sell, rent, or share your data except when:",
      d1: "•	With your explicit authorization and consent;",
      d2: "•	To fulfill legal obligations or respond to judicial requests;",
      d3: "•	In collaboration with verified academic institutions for training or content publication (limited to what is necessary).",
    },
    t6: {
      t: "六、Cookies & Tracking",
      d: "We may use cookies for session optimization only, not for ad tracking. You can disable them in your browser settings.",
    },
    t7: {
      t: "七、Your Rights",
      d: "You have the right to:",
      d1: "•	Access, correct or delete your account data;",
      d2: "•	Withdraw consent or close your account;",
      d3: "•	File a complaint regarding data handling with us.",
    },
    t8: {
      t: "八、Updates",
      d: "We may update this policy periodically. Any changes will be announced on the platform, and significant updates will be communicated via email or app notice.",
    },
    t9: {
      t: "九、Copyright",
      d: "MISN holds copyright on all material presented on our website.",
    },
    t10: {
      t: "十、Contact Us",
      d: "If you have any questions, please contact:",
      d1: "Email: misnmed@gmail.com",
    },
  },
  // 免责声明
  disclaimer: {
    title: "Disclaimer",
    t1: {
      t: "The content on this website is intended for professional medical education and academic exchange only, and should not be construed as medical advice or a substitute for clinical judgment. ",
    },
    t2: {
      t: "All surgical videos are de-identified. First author is responsible for obtaining consent from patients, institutions, or hospitals regarding the use of any videos, logos, content, or data. Unauthorized distribution is prohibited.",
    },
  },
  cookie: {
    t1: "This website uses cookies to provide you with a better browsing experience. Learn more about",
    t2: ".If you click the confirmation button on the right, you will be deemed to agree to the use of cookies.",
    jsBtn: "Accept",
  },
  //隐私条款
  newPrivacyAgreement: {
    title: "Disclaimer",
    content: `The content on this website is intended for professional medical education and academic exchange only, and should not be construed as medical advice or a substitute for clinical judgment.<br />All surgical videos are de-identified. First author is responsible for obtaining consent from patients, institutions, or hospitals regarding the use of any videos, logos, content, or data. Unauthorized distribution is prohibited.
`,
  },
  // pc版使用手册
  pcVUse:{
    title:"MISN Website User Manual（PC Version)",
    t1:{
      d1:'This manual provides a detailed guide for using the PC version of the MISN (Minimally Invasive Surgeons Network) website.',
      d2:'Intended Readers: Doctors, operations personnel, project managers, technical developers, QA engineers, and other relevant users.',
      d3:'Note: If there is any discrepancy between the screenshots in this guide and the actual interface, please refer to the actual website interface.',
    },
    t2:{
      t:'1.1 Registration',
      d:"After accessing the website: www.misnmed.com, If you are not yet registered, click the Log In button in the top-right menu.You will see a prompt: “If you don’t have an account yet, please Sign Up first and then log in.” Click to proceed to the registration page.",
      d1:'Fill in your personal information, choose Email verification, and complete the registration process.',
      d2:'Upon successful registration, you will be directed to the login page.',
    },
    t3:{
      t:'1.2 Log in',
      d:'For registered users, click the [Log in] button in the top right corner.',
      d1:'Choose to log in using email verification code.',
      d2:'Once logged in, you can access the full website features.',
    },
    t4:{
      t:'1.3 Case Submission',
      d:'Doctors can share case discussions through three entry points:',
      d1:'Entry 1 & 2: Click [Case Exchange] → [Post Case]',
      d2:'Entry 3: Hover over the avatar in the top right corner and click [My Cases] to enter your personal page. Then, click [Post Case].',
      d3:'Agree to the terms of service.Fill in the case details, select a category, and input case information (click [AI Polish] to refine content).',
      d4:'Click [Submit] to proceed to the translation step.',
      d5:'The system will automatically translate to English. You may revise or accept the default.',
      d6:'Click [Confirm release] to submit for review.',
      d7:'Review results will be notified via system messages.',
      d8:'Rejected cases will show reasons and can be resubmitted; approved ones will be published.',
    },
    t5:{
      t:'1.4 Video Submission',
      d:'Doctors can upload surgical videos through three entry points:',
      d1:'Entry 1 & 2: Click [Surgical Videos] → [Post Video]',
      d2:'Entry 3: Hover over the avatar and click [My Video] → [Post Video].',
      d3:'Agree to the terms of service. Upload your video via click or drag-and-drop.',
      d4:'The first frame is used as the thumbnail by default, or you can upload your own.',
      d5:'Fill in video description, select category, and enter case info (AI enhancement available).',
      d6:'Click [Submit] to proceed to translation.',
      d7:'The system will auto-translate to English. You may revise or use default.',
      d8:'Click [Confirm Release] to submit for review.',
      d9:'Notification of results will be via system messages.',
      d10:'Rejected videos can be edited and resubmitted; approved videos will be published.',
    },
    t6:{
      t:'1.5 Case Sharing',
      d:'In this section, you can engage in case discussions, post your own cases, and interact with other doctors.',
      d1:'Features include filtering by category, sorting by latest/popular, or keyword search.',
      d2:'Click to enter case detail page for full information.',
      d3:'Bilingual viewing and commenting supported.',
    },
    t7:{
      t:'1.6 Surgical Videos',
      d:'You can view surgical videos shared by other doctors and exchange insights, or upload your own.',
      d1:'Features include category filter, sort by latest/popular, and keyword search.',
      d2:'Click to enter video detail page. Author info is shown on the right, with a Follow option.',
      d3:'Bilingual display and comment section supported.',
    },
    t8:{
      t:'1.7 International Conferences',
      d:'View the latest updates on international conferences in this section. Click to view details.',
    },
    t9:{
      t:'1.8 Medical Information',
      d:'Stay updated with the latest medical news. Supports keyword search and sorting by Recent Updates/Top Updates. Click to view details.',
    },
    t10:{
      t:'1.9 Personal Center',
      d:'Hover over the avatar in the top right corner and click to enter your personal center.',
    },
    t11:{
      t:'1.9.1 Edit Personal Info',
      d:'Click [Edit] to modify your profile and [Save] to apply changes.'
    },
    t12:{
      t:'1.9.2 Following & Followers',
      d:'Click [Following/Followers] to view users you follow and your followers.',
    },
    t13:{
      t:'1.9.3 My Cases',
      d:'Click [Case] to view your submitted cases. Supports filter, search, edit, and delete.'
    },
    t14:{
      t:'1.9.4 My Videos',
      d:'Click [Video] to view your uploaded videos. Supports filter, search, edit, and delete.',
    },
    t15:{
      t:'1.9.5 My Favorites',
      d:'Click [Favorites] to view bookmarked items. Supports filter, search, edit, and delete.'
    },
    t16:{
      t:'1.9.6 Browsing History',
      d:'Click [Browsing History] to view browsing history. Supports filter and keyword search.'
    },
    bottom:{
      t:'We appreciate your continued support.'
    }
  },
  // 移动版使用手册
  mbVUse:{
    title:'MISN Website User Manual（Mobile Version)',
    t1:{
      d1:'This manual provides a detailed guide for using the mobile version of the MISN (Minimally Invasive Surgeons Network) website.',
      d2:'Intended Readers: Doctors, operations personnel, project managers, technical developers, QA engineers, and other relevant users.',
      d3:'Note: If there is any discrepancy between this user guide and the actual interface, please refer to the actual website interface.',
    },
    t2:{
      t:'1.1 Registration',
      d:"After accessing the website: www.misnmed.com, If you are not yet registered, click the Log In button in the top-right menu.You will see a prompt: “If you don’t have an account yet, please Sign Up first and then log in.” Click to proceed to the registration page.",
      d1:'Fill in your personal information, choose Email verification, and complete the registration process.',
      d2:'Upon successful registration, you will be directed to the login page.'
    },
    t3:{
      t:'1.2 Log in',
      d:'For registered users, click the [Log in] button in the menu bar in the top right corner.',
      d1:'Choose to log in using email verification code.',
      d2:'Once logged in, you can access the full website features.',
    },
    t4:{
      t:'1.3 Case Submission',
      d:'Doctors can share case discussions through three entry points:',
      d1:'Entry 1 & 2: Click [Case Exchange] → [Post Case]',
      d2:'Entry 3: Hover over the avatar in the top right corner and click [My Cases] to enter your personal page. Then, click [Post Case].',
      d3:'Agree to the terms of service. Fill in the case details, select a category, and input case information (click [AI Polish] to refine content).',
      d4:'Click [Submit] to proceed to the translation step.',
      d5:'The system will automatically translate to English. You may revise or accept the default.',
      d6:'Click [Confirm release] to submit for review.',
      d7:'Review results will be notified via system messages.',
      d8:'Rejected cases will show reasons and can be resubmitted; approved ones will be published.',
    },
    t5:{
      t:'1.4 Video Submission',
      d:'Doctors can upload surgical videos through three entry points:',
      d1:'Entry 1 & 2: Click [Surgical Videos] → [Post Video]',
      d2:'Entry 3: Hover over the avatar and click [My Video] → [Post Video].',
      d3:'Agree to the terms of service. Upload your video via click or drag-and-drop.',
      d4:'The first frame is used as the thumbnail by default, or you can upload your own.',
      d5:'Fill in video description, select category, and enter case info (AI enhancement available).',
      d6:'Click [Submit] to proceed to translation.',
      d7:'The system will auto-translate to English. You may revise or use default.',
      d8:'Click [Confirm Release] to submit for review.',
      d9:'Notification of results will be via system messages.',
      d10:'Rejected videos can be edited and resubmitted; approved videos will be published.',
    },
    t6:{
      t:'1.5 Case Sharing',
      d:'In this section, you can engage in case discussions, post your own cases, and interact with other doctors.',
      d1:'Features include filtering by category, sorting by latest/popular, or keyword search.',
      d2:'Click to enter case detail page for full information.',
      d3:'Bilingual viewing and commenting supported.',
    },
    t7:{
      t:'1.6 Surgical Videos',
      d:'You can view surgical videos shared by other doctors and exchange insights, or upload your own.',
      d1:'Features include category filter, sort by latest/popular, and keyword search.',
      d2:'Click to enter video detail page. Author info is shown on the right, with a Follow option.',
      d3:'Bilingual display and comment section supported.',
    },
    t8:{
      t:'1.7 International Conferences',
      d:'View the latest updates on international conferences in this section. Click to view details.',
    },
    t9:{
      t:'1.8 Medical Information',
      d:'Stay updated with the latest medical news. Supports keyword search and sorting by Recent Updates/Top Updates. Click to view details.'
    },
    t10:{
      t:'1.9 Personal Center',
      d:'Hover over the avatar in the top right corner and click to enter your personal center.',
    },
    t11:{
      t:'1.9.1 Edit Personal Info',
      d:'Click [Edit] to modify your profile and [Save] to apply changes.'
    },
    t12:{
      t:'1.9.2 Following & Followers',
      d:'Click [Following/Followers] to view users you follow and your followers.'
    },
    t13:{
      t:'1.9.3 My Cases',
      d:'Click [Case] to view your submitted cases. Supports filter, search, edit, and delete.',
    },
    t14:{
      t:'1.9.4 My Videos',
      d:'Click [Video] to view your uploaded videos. Supports filter, search, edit, and delete.',
    },
    t15:{
      t:'1.9.5 My Favorites',
      d:'Click [Favorites] to view bookmarked items. Supports filter, search, edit, and delete.',
    },
    t16:{
      t:'1.9.6 Browsing History',
      d:'Click [Browsing History] to view browsing history. Supports filter and keyword search.',
    },
    bottom:{
      t:'We appreciate your continued support.'
    }
  }
};
